import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import React from 'react'

import { Button, Col, Modal, Row } from 'antd'
import { useWindowSize } from 'flynk.app.web.core.components/helpers'
import PropTypes from 'prop-types'

import { useStores } from '@/helpers/common'

import {
  GIG_TYPES,
  NO_CEREMONY,
  NO_PERFORMANCE,
  PERFORMANCE_GROUPS_DISPLAY,
  QUOTE_BUILDER_BREAKPOINT,
} from '../../../constants'
import { ModalGroupTitle } from '../ModalGroupTitle'
import CeremonyMusicModalItem from './CeremonyMusicModalItem'

export const CeremonyMusicGroupModal = ({
  booking,
  group,
  wrapClassName,
  handleCancelCallBack,
  performances,
  selectCeremonyPerformance,
  selectCeremonyPerformanceLoading,
  toggleCeremonyMusicGroupModalVisible,
  selectedCeremonyPerformance,
}) => {
  const {
    bookingStore: { isPrivateEventBooking },
  } = useStores()

  const handelCancel = () => {
    toggleCeremonyMusicGroupModalVisible()
    handleCancelCallBack()
  }

  const { windowInnerHeight } = useWindowSize(QUOTE_BUILDER_BREAKPOINT)

  const onSelectItemClick = async id => {
    await selectCeremonyPerformance(id)
    toggleCeremonyMusicGroupModalVisible()
    handleCancelCallBack()
  }

  const closeButton = (
    <Button key={222} type="text" className="qb-button" onClick={handelCancel}>
      <FontAwesomeIcon
        icon={['fas', 'chevron-left']}
        className="font-awesome-icon"
      />
    </Button>
  )

  const performancesLength = performances.length

  const noPerformanceLabel = isPrivateEventBooking
    ? NO_PERFORMANCE.Ceremony.privateLabel
    : NO_PERFORMANCE.Ceremony.label

  const modalGroupTitle =
    PERFORMANCE_GROUPS_DISPLAY[group] === NO_PERFORMANCE.Ceremony.label
      ? noPerformanceLabel
      : PERFORMANCE_GROUPS_DISPLAY[group]

  const noPerformanceDescLabel = (
    isPrivateEventBooking ? GIG_TYPES.Background : GIG_TYPES.Ceremony
  ).toLowerCase()

  return (
    <Modal
      open
      centered
      footer={null}
      closable={false}
      onCancel={handelCancel}
      maskClosable
      width="100%"
      wrapClassName={wrapClassName}
      className="qb-modal qb-group-modal"
      style={{ maxHeight: windowInnerHeight }}
      title={
        <ModalGroupTitle buttons={[closeButton]} title={modalGroupTitle} />
      }
      getContainer="#qbDetails"
    >
      <div className="qb-group-modal-content qb-scroll">
        {performancesLength ? (
          performances.map((performance, index) => {
            const gutter = index < performancesLength - 1 ? [0, 30] : 0

            return (
              <Row key={performance.id} gutter={gutter}>
                <Col xs={24}>
                  <CeremonyMusicModalItem
                    performance={performance}
                    selectCeremonyPerformance={onSelectItemClick}
                    selectCeremonyPerformanceLoading={
                      selectCeremonyPerformanceLoading
                    }
                    booking={booking}
                  />
                </Col>
              </Row>
            )
          })
        ) : (
          <Row>
            <Col xs={24}>
              <div className="band-modal-content-ceremony-list-item-no-cat">
                <div className="band-modal-content-ceremony-list-item-no-cat__icon no-cat__icon">
                  <img src="/images/no-cat-icon.svg" alt="no-cat-icon" />
                </div>
                <div className="band-modal-content-ceremony-list-item-no-cat__info">
                  <p className="band-modal-content-no-cat__title no-cat__title">
                    {noPerformanceLabel}
                  </p>
                  <p className="band-modal-content-no-cat__des">
                    Select this option if you don’t need us for your{' '}
                    {noPerformanceDescLabel} music.
                  </p>
                  {selectedCeremonyPerformance.id === NO_CEREMONY ? (
                    <Button
                      type="primary"
                      className="qb-button qb-button-change selected"
                    >
                      Selected
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      className="qb-button qb-button-change"
                      onClick={() => selectCeremonyPerformance(NO_CEREMONY)}
                    >
                      Select
                    </Button>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </Modal>
  )
}

CeremonyMusicGroupModal.defaultProps = {
  wrapClassName: '',
  selectedCeremonyPerformance: null,
}

CeremonyMusicGroupModal.propTypes = {
  booking: MobxPropTypes.objectOrObservableObject.isRequired,
  group: PropTypes.number.isRequired,
  handleCancelCallBack: PropTypes.func.isRequired,
  performances: MobxPropTypes.arrayOrObservableArray.isRequired,
  toggleCeremonyMusicGroupModalVisible: PropTypes.func.isRequired,
  selectCeremonyPerformance: PropTypes.func.isRequired,
  selectCeremonyPerformanceLoading: PropTypes.bool.isRequired,
  selectedCeremonyPerformance: MobxPropTypes.objectOrObservableObject,
  wrapClassName: PropTypes.string,
}

export default observer(CeremonyMusicGroupModal)
